module.exports = __webpack_public_path__ + "static/media/DigiSpanpraat_Thumbnail.215ba2a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/DigiSpanpraat_Thumbnail.jpg
// module id = 816
// module chunks = 3